import Page from '@/components/pages/podcasts/PodcastsPageController';
import getStaticProps from '@/components/pages/podcasts/PodcastsPageStaticProps';

export default Page;
export { getStaticProps };
